<template>
  <div class="publish-product-setting">
    <!-- 游戏图标和名称 -->
    <div class="publish-product-games-icon-and-name">
        <img class="publish-product-games-icon"  :src="currentSelectedGameItem.gameIcon" alt="游戏图标">
        <p class="publish-product-games-name">{{currentSelectedGameItem.gameName}}</p>
    </div>
    <!-- 表单 -->
    <div class="publish-product-setting-form" v-for="(item,index) in currentInputGameModelList.slice(-6)" :key="index">
        <!-- 输入框 -->
        <publish-product-form-input 
        v-if="item.type==='input'" 
        :title="item.title" 
        :aliasTitle="item.aliasTitle"
        :placeholder="item.placeholder"
        :asRequired="item.asRequired"
        :asShowUnit="item.asShowUnit"
        >
        <div class="publish-product-form-input-tips">
            <p class="publish-product-form-input-tips-text">{{ item.tips }}</p>
        </div>
        </publish-product-form-input>
        <!-- 单选框 -->
        <publish-product-form-radio
        v-if="item.type==='radio'"
        :title="item.title"
        :aliasTitle="item.aliasTitle"
        :dataList="item.dataList"
        :asRequired="item.asRequired"
        ></publish-product-form-radio>
    </div>
    <!-- 操作按钮 -->
    <div class="publish-product-setting-btn-box">
        <div class="publish-product-setting-go-back-btn" @click="clickGoBackBtnHandler()">
            <p class="publish-product-setting-go-back-btn-text">上一步</p>
        </div>
        <div class="publish-product-setting-commit-btn" @click="clickCommitBtnHandler()">
            <p class="publish-product-setting-commit-btn-text">提交</p>
        </div>
    </div>
  </div>
</template>

<script>
import PublishProductFormInput from './publish-product-form-input.vue';
import PublishProductFormRadio from './publish-product-form-radio.vue';
import {webPublishProduct} from '@/services/publishProduct/index'
import  {mapState,mapMutations}  from 'vuex';
export default {
    name:"PublishProductSetting",
    components:{
        PublishProductFormInput,
        PublishProductFormRadio
    },
    data(){
        return{
            // formData:[
            //     {
            //         type:'input',
            //         title:'联系QQ',
            //         aliasTitle:'QQ',
            //         placeholder:'请输入联系QQ',
            //         asRequired:true,
            //         asShowUnit:false,
            //         tips:''
            //     },
            //     {
            //         type:'input',
            //         title:'联系微信',
            //         aliasTitle:'weiXin',
            //         placeholder:'请输入联系微信',
            //         asRequired:true,
            //         asShowUnit:false,
            //         tips:''
            //     },
            //     {
            //         type:'input',
            //         title:'联系电话',
            //         aliasTitle:'contactPhone',
            //         placeholder:'请输入联系电话',
            //         asRequired:true,
            //         asShowUnit:false,
            //         tips:''
            //     },
            //     {
            //         type:'radio',
            //         title:'是否支持包赔',
            //         aliasTitle:'asSupportIndemnity',
            //         dataList:['是','否'],
            //         asRequired:true 
            //     },
            //     {
            //         type:'radio',
            //         title:'有无防沉迷',
            //         aliasTitle:'asFcm',
            //         dataList:['无防沉迷','有防沉迷'],
            //         asRequired:true 
            //     },
            //     {
            //         type:'radio',
            //         title:'是否接受砍价',
            //         aliasTitle:'asSupportBargain',
            //         dataList:['是','否'],
            //         asRequired:true 
            //     },
            // ]
        }
    },
    methods:{
        ...mapMutations('publishProduct',['setCurrentStepsIndex']),
        //返回上一步
        clickGoBackBtnHandler(){
            this.setCurrentStepsIndex(this.currentStepsIndex-1);
        },
        //点击提交按钮
        async clickCommitBtnHandler(){
            //提交用户输入的游戏模型
            const loading = this.$loading({
                lock: true,
                text: '正在提交中，需等待大约30秒左右',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try{
                const {data} = await webPublishProduct(this.currentSelectObjectProperty);
                if(data.code == 200){
                    //console.log('提交用户输入的游戏模型===成功')
                    //console.log(data.data);
                }else if(data.code==500){
                    this.$message.warning('缺少参数');
                    loading.close();
                    return;
                }else if(data.code==9){
                    this.$message.warning('用户不存在');
                    loading.close();
                    return;
                }else if(data.code==33){
                    this.$message.warning('请先进行实名认证和实人认证');
                    loading.close();
                    return;
                }
            }catch(err){}
            loading.close();
            this.setCurrentStepsIndex(this.currentStepsIndex+1);
        }
    },
    computed:{
        ...mapState({
            currentStepsIndex:state=>state.publishProduct.currentStepsIndex,
            currentSelectedGameItem:state=>state.publishProduct.currentSelectedGameItem,
            currentInputGameModelList:state=>state.publishProduct.currentInputGameModelList,
            currentSelectObjectProperty:state=>state.publishProduct.currentSelectObjectProperty
        })
    },
    mounted(){
        //console.log(this.currentInputGameModelList)
    }
}
</script>

<style lang="less" scoped>
.publish-product-setting{
    margin-top: 30px;
    padding-bottom: 30px;
    width: 1200px;
    background: #FFFFFF;
    border-radius: 8px;
    .publish-product-games-icon-and-name{
        margin-left: 50px;
        width: 1100px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        .publish-product-games-icon{
            margin-top: 20px;
            width: 40px;
            height: 40px;
            border-radius: 10px;
        }
        .publish-product-games-name{
            margin-top: 20px;
            margin-left: 14px;
            height: 19px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 14px;
            color: #1A1A1A;
            line-height: 19px;
            text-align: left;
            font-style: normal;
        }
    }
    .publish-product-setting-form{
        width: 1200px;
        background: #FFFFFF;
    }
    .publish-product-setting-btn-box{
        margin-top: 50px;
        width: 1200px;
        display: flex;
        justify-content: center;
        .publish-product-setting-go-back-btn{
            width: 160px;
            height: 50px;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #E5E5E5;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: default;
            .publish-product-setting-go-back-btn-text{
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #555555;
                line-height: 16px;
                text-align: right;
                font-style: normal;
            }
        }
        .publish-product-setting-commit-btn{
            margin-left: 20px;
            width: 160px;
            height: 50px;
            background: #F02233;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: default;
            .publish-product-setting-commit-btn-text{
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 16px;
                text-align: right;
                font-style: normal;
            }
        }
    }
}
</style>